<template>
  <PulseLoader
    :color="color"
  />
</template>
<script>
import PulseLoader from 'vue-spinner/src/PulseLoader'
import { theme } from '@converdy/styles/theme'

export default {
  name: 'Spinner',
  
  components: {
    PulseLoader
  },
  
  data() {
    return {
      color: theme.extend.colors.primary.default
    }
  }
}

</script>
